<template>
<div id="app_mobile_aside" style="display:none;">
  <div class="row h-100">
    <div class="col-8 h-100 shadow-sm bg-white">
      <div class="text-left m-2 pt-4" id="mobile_aside_menu_close_btn" @click="closeMenu()">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            fill="#a0a0a0"
            width="24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </div>
      <div class="mt-5" id="sidebar_menu">
        <ul class="list-unstyled">
          <li v-for="(item, index) in menu" :key="index" :class="item.url == $route.fullPath ? 'sidebar_active_item sidebar_item' : 'sidebar_item'">
            <router-link :to="item.url" v-if="is_authenticated || !item.need_auth">
              <span v-html="item.icon"></span>
              <span class="pr-2">{{ item.title }}</span>
            </router-link>
            <span v-else style="cursor: not-allowed !important;">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#a0a0a0"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
                <span class="pr-2">{{ item.title }}</span>
              </span>
          </li>
          <!-- add Social Store -->
<!--          <li class="sidebar_item">-->
<!--            <a href="#" @click="redirectToShop()">-->
<!--              <div>-->
<!--              <span>-->
<!--                <social-store-svg></social-store-svg>-->
<!--              </span>-->
<!--                <span class="pr-2">فروشگاه شبکه های اجتماعی</span>-->
<!--              </div>-->
<!--            </a>-->
<!--          </li>-->
        </ul>
      </div>
    </div>
    <div class="col-4 h-100" @click="closeMenu()"></div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import menu from "@/components/main/aside.js";
import SocialStoreSvg from '../svg/SocialStoreSvg.vue'
import {mapGetters} from "vuex";
import { getToken } from '@/common/jwt.service.js';
import {SHOP_LOGIN,PEGEN_LOGIN,SHOP_REFRENCE,LOGIN_REFRENCE,VERIFY_REFRENCE} from "@/common/config";
export default {
  name: "mobile-aside",
  computed: {
    ...mapGetters('dashboard', [
      'dashboard', "status"
    ]),

    ...mapGetters("pardakhtShakhsi", [
      "form_data"
    ]),

    ...mapGetters('user', [
      'is_authenticated',
      'is_authenticated_pending'
    ]),
  },
  data() {
    return {
      // these live in the bottom tab bar (mobile-tabbar.vue), so they are not repeated in the hamburger menu
      menu : menu.filter(item => !['/', '/gateways', '/transactions', '/user-setting'].includes(item.url))
    };
  },
   components:{
    SocialStoreSvg
  },
  methods: {
    closeMenu() {
      $('#app_mobile_aside').animate({width: 'toggle'}, 100);
    },
    redirectToShop() {
      if(document.referrer === SHOP_REFRENCE || document.referrer === '' || document.referrer === LOGIN_REFRENCE || document.referrer === VERIFY_REFRENCE){
        let token = getToken();
        let link = document.createElement("a");
        link.href = SHOP_LOGIN + "/panel/" + token;
        document.body.appendChild(link);
        link.click();
      }else{
        let token = getToken();
        let link = document.createElement("a");
        link.href = PEGEN_LOGIN + "/panel/" + token;
        document.body.appendChild(link);
        link.click();
      }
    },    
  }
};
</script>
